import * as React from 'react'
import UIMessages from 'src/utils/ui-messages'
import FindIcon from '../icons/ui/Find'

interface IPromotionsSearch {
  onInputChange: (title: string) => void
}

const PromotionsSearch = (props: IPromotionsSearch) => {
  const [searchValue, setSearchValue] = React.useState('')
  const handleInputChange = (e: any) => {
    const { onInputChange } = props
    const regex = /[\\\/\$\|\&\#\.\?]/g
    const searchString = e.target.value.replaceAll(regex, '')
    setSearchValue(searchString)
    onInputChange(searchString)
  }

  return (
    <div className='flex items-center mr3'>
      <input
        className='w3-input mr1'
        type='text'
        value={searchValue}
        onChange={handleInputChange}
        placeholder={UIMessages.common.search}
      />
      <FindIcon className='svg-stroke-grey3' />
    </div>
  )
}

export default PromotionsSearch



// WEBPACK FOOTER //
// ./src/components/promotions/PromotionsSearch.tsx